import Vue from 'vue';
import * as C from '../constants';

export default {
  [C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_PENDING](state) {
    Vue.set(state, 'suppliers', {
      loading: true,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_SUCCESS](state, payload) {
    Vue.set(state, 'suppliers', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SUPPLIERS_FAILURE](state) {
    Vue.set(state, 'suppliers', {
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_TRANSITS_PENDING](state) {
    Vue.set(state, 'transits', {
      loading: true,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_TRANSITS_SUCCESS](state, payload) {
    Vue.set(state, 'transits', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_TRANSITS_FAILURE](state) {
    Vue.set(state, 'transits', {
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CARRIERS_PENDING](state) {
    Vue.set(state, 'carriers', {
      loading: true,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CARRIERS_SUCCESS](state, payload) {
    Vue.set(state, 'carriers', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CARRIERS_FAILURE](state) {
    Vue.set(state, 'carriers', {
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CARRIERS_NO_CONTENT](state) {
    Vue.set(state, 'carriers', {
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_PENDING](state) {
    Vue.set(state, 'transport', {
      ...state.transport,
      loading: true,
      error: false,
      item: null,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_SUCCESS](state, payload) {
    Vue.set(state, 'transport', {
      ...state.transport,
      loading: false,
      error: false,
      item: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_TRANSPORT_FAILURE](state) {
    Vue.set(state, 'transport', {
      ...state.transport,
      loading: false,
      error: true,
      item: null,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_PENDING](state) {
    Vue.set(state, 'siblingTransport', {
      ...state.siblingTransport,
      loading: true,
      error: false,
      item: null,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_SUCCESS](state, payload) {
    Vue.set(state, 'siblingTransport', {
      ...state.siblingTransport,
      loading: false,
      error: false,
      item: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SAVE_SIBLING_TRANSPORT_FAILURE](state) {
    Vue.set(state, 'siblingTransport', {
      ...state.siblingTransport,
      loading: false,
      error: true,
      item: null,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_PENDING](state) {
    Vue.set(state, 'contractUpload', {
      ...state.contractUpload,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_SUCCESS](state) {
    Vue.set(state, 'contractUpload', {
      ...state.contractUpload,
      loading: false,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPLOAD_CONTRACTS_FAILURE](state) {
    Vue.set(state, 'contractUpload', {
      ...state.contractUpload,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_PENDING](state) {
    Vue.set(state, 'seatingSectionTypes', {
      ...state.seatingSectionTypes,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'seatingSectionTypes', {
      ...state.seatingSectionTypes,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_FAILURE](state) {
    Vue.set(state, 'seatingSectionTypes', {
      ...state.seatingSectionTypes,
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEATING_SECTION_TYPES_NO_CONTENT](state) {
    Vue.set(state, 'seatingSectionTypes', {
      ...state.seatingSectionTypes,
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_PENDING](state) {
    Vue.set(state, 'consumableTypes', {
      ...state.consumableTypes,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'consumableTypes', {
      ...state.consumableTypes,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_FAILURE](state) {
    Vue.set(state, 'consumableTypes', {
      ...state.consumableTypes,
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_CONSUMABLE_TYPES_NO_CONTENT](state) {
    Vue.set(state, 'consumableTypes', {
      ...state.consumableTypes,
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_PENDING](state) {
    Vue.set(state, 'upgradeTypes', {
      ...state.upgradeTypes,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'upgradeTypes', {
      ...state.upgradeTypes,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_FAILURE](state) {
    Vue.set(state, '', {
      ...state.upgradeTypes,
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_UPGRADE_TYPES_NO_CONTENT](state) {
    Vue.set(state, 'upgradeTypes', {
      ...state.upgradeTypes,
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_PENDING](state) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_SUCCESS](state, payload) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_SEATINGS_FAILURE](state) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_PENDING](state) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_SUCCESS](state, payload) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_CONSUMABLES_FAILURE](state) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_PENDING](state) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_SUCCESS](state, payload) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_TRIP_UPGRADES_FAILURE](state) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_PENDING](state) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_SUCCESS](state, payload) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_FAILURE](state) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_SEATINGS_NO_CONTENT](state) {
    Vue.set(state, 'tripSeatings', {
      ...state.tripSeatings,
      loading: false,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_PENDING](state) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_SUCCESS](state, payload) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_FAILURE](state) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_CONSUMABLES_NO_CONTENT](state) {
    Vue.set(state, 'tripConsumables', {
      ...state.tripConsumables,
      loading: false,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_PENDING](state) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_SUCCESS](state, payload) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_FAILURE](state) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_TRIP_UPGRADES_NO_CONTENT](state) {
    Vue.set(state, 'tripUpgrades', {
      ...state.tripUpgrades,
      loading: false,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_PENDING](state) {
    Vue.set(state, 'luggageTypes', {
      ...state.luggageTypes,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_SUCCESS](state, payload) {
    Vue.set(state, 'luggageTypes', {
      ...state.luggageTypes,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_TYPES_FAILURE](state) {
    Vue.set(state, 'luggageTypes', {
      ...state.luggageTypes,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_PENDING](state) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_SUCCESS](state, payload) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SYNC_TRANSPORT_LUGGAGE_FAILURE](state) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_PENDING](state) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_SUCCESS](state, payload) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_NO_CONTENT](state) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_LUGGAGE_FAILURE](state) {
    Vue.set(state, 'transportLuggage', {
      ...state.transportLuggage,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_PENDING](state) {
    Vue.set(state, 'contracts', {
      ...state.contracts,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_SUCCESS](state, payload) {
    Vue.set(state, 'contracts', {
      ...state.contracts,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_FAILURE](state) {
    Vue.set(state, 'contracts', {
      ...state.contracts,
      loading: false,
      error: true,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_GET_CONTRACTS_NO_CONTENT](state) {
    Vue.set(state, 'contracts', {
      ...state.contracts,
      loading: false,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_PENDING](state) {
    Vue.set(state, 'transport', {
      loading: true,
      error: false,
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_SUCCESS](state, payload) {
    Vue.set(state, 'transport', {
      loading: false,
      error: false,
      item: payload,
    });
  },

  /**
   * @param state
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_TRANSPORT_FAILURE](state) {
    Vue.set(state, 'transport', {
      loading: false,
      error: true,
      item: {},
    });
  },

  /**
   * @param state
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_LIST_PENDING](state) {
    Vue.set(state, 'overview', {
      loading: true,
      error: false,
      items: [],
    });
  },

  /**
   * @param state
   * @param payload
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_LIST_SUCCESS](state, payload) {
    Vue.set(state, 'overview', {
      loading: false,
      error: false,
      items: payload,
    });
  },

  /**
   * @param state
   */
  [C.NON_DYNAMIC_TRANSPORT_GET_LIST_FAILURE](state) {
    Vue.set(state, 'overview', {
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEARCH_PENDING](state) {
    Vue.set(state, 'searchTransports', {
      ...state.searchTransports,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEARCH_SUCCESS](state, payload) {
    Vue.set(state, 'searchTransports', {
      ...state.searchTransports,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEARCH_FAILURE](state) {
    Vue.set(state, 'searchTransports', {
      ...state.searchTransports,
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_SEARCH_NO_CONTENT](state) {
    Vue.set(state, 'searchTransports', {
      ...state.searchTransports,
      loading: false,
      error: false,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_PENDING](state) {
    Vue.set(state, 'searchTransportsPriceSetting', {
      ...state.searchTransportsPriceSetting,
      loading: true,
      error: false,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_SUCCESS](state, payload) {
    Vue.set(state, 'searchTransportsPriceSetting', {
      ...state.searchTransportsPriceSetting,
      loading: false,
      error: false,
      items: payload,
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_FAILURE](state) {
    Vue.set(state, 'searchTransportsPriceSetting', {
      ...state.searchTransportsPriceSetting,
      loading: false,
      error: true,
      items: [],
    });
  },

  [C.NON_DYNAMIC_TRANSPORT_PRICE_SETTING_SEARCH_NO_CONTENT](state) {
    Vue.set(state, 'searchTransportsPriceSetting', {
      ...state.searchTransportsPriceSetting,
      loading: false,
      error: false,
      items: [],
    });
  },
};




// WEBPACK FOOTER //
// ./src/store/modules/non-dynamic-transport/mutations.js